<template>
  <!--通用弹出框-->
  <div class="dialog">
    <el-dialog
        :title="dOptions.title"
        :visible.sync="dOptions.visible"
        :close-on-click-modal="dOptions.modal"
        :show-close="dOptions.isCloseShow"
        width="30%"
        center>
      asdfas
      <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="confirmDialog">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MyDialog",
  props: {
    options: {
      type: Object,
      default: ()=>{}
    },
    // visible:{
    //   type: Boolean,
    //   default: false
    // },
    // title: {
    //   type: String,
    //   default: '标题'
    // },
    // // 打开关闭
    // show: {
    //   type: Boolean,
    //   default: false
    // },
    // // 遮罩层
    // modal: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      dOptions:{}
    }
  },
  mounted() {
    this.dOptions = this.options;
    console.log('this.options-----',this.options)
  },
  watch: {
    options(newValue, oldValue) {
      console.log('xxx', newValue,oldValue)
    }
  },
  created() {
    // console.log('this.options',this.options)
  },
  computed:{
    // initdata (){
    //  return this.dOptions = this.options;
    // }
  },
  methods: {
    closeDialog() {
      // this.centerDialogVisible = false;
      this.$emit('closeDialog', false)
      console.log('close')
    },
    confirmDialog() {
      // this.centerDialogVisible = false;
      this.$emit('confirmDialog', false)
      console.log('confirm')
    },
  }

}
</script>

<style scoped>

</style>
